export const ProgressExpandButton = ({
  isExpanded,
}: {
  isExpanded: boolean;
}) => {
  return (
    <button className="mr-2 box-border inline-flex cursor-pointer appearance-none focus:outline-none">
      {isExpanded ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
        >
          <path
            d="M1 7.5L7 1.5L13 7.5"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
        >
          <path
            d="M13 1.5L7 7.5L1 1.5"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
};
